import { Permissions } from '../../../../models/enums/permissions';
import * as React from 'react';
import { HasPermission } from '../../../../containers/authorization-helpers/HasPermission';
import { ShipmentNotificationTypeMetadata } from '../../../../transportation/models/enums/notification-type';

interface IProps {
    sendNotifications: any;
    downloadRunLogs: any;
    downloadRunLogExports: any;
}

export const CommunicationsRightClickMenu = (props: IProps) => {
    return (
        <div>
            <p>Send</p>
            <HasPermission requiredPermissions={[
                Permissions.CommunicationsShipmentsTrucksSend, Permissions.CommunicationsShipmentsContainersSend
            ]}>
                <button onClick={() => props.sendNotifications(ShipmentNotificationTypeMetadata.productionSummary)}>
                    <i className="la la-legal" />
                    Production Summary
                </button>
                <button onClick={() => props.sendNotifications(ShipmentNotificationTypeMetadata.preliminaryDelivery)}>
                    <i className="la la-truck" />
                    Preliminary Delivery
                </button>
                <button onClick={() => props.sendNotifications(ShipmentNotificationTypeMetadata.finalDelivery)}>
                    <i className="la la-truck" />
                    Final Delivery
                </button>
            </HasPermission>
            <HasPermission requiredPermissions={[
                Permissions.CommunicationsShipmentsTrucksView, Permissions.CommunicationsShipmentsContainersView
            ]}>
                <div className="right-click-divide" />
                <p>Download</p>
                <button onClick={() => props.downloadRunLogs()}>
                    <i className="la la-legal" />
                    Run Logs
                </button>
                <button onClick={() => props.downloadRunLogExports()}>
                    <i className="la la-legal" />
                    Run Log Exports
                </button>
            </HasPermission>

        </div>
    );
};
